export default function NeedsSection() {
  return (
    <section className="sec g" style={{ backgroundColor: "#FFFFFF" }}>
      <div className="wrap">
        <div className="hd2 rv">
          <div>
            <small>AI 도입, 어디서부터 시작해야 할지 막막하다면</small>
            <h2>
              우리 조직에
              {' '}
              <em>AcXion-On</em>
              이 필요한 순간
            </h2>
          </div>
        </div>
        <div className="who3">
          <div className="bc hasgo gp rv">
            <div className="t">
              <svg className="i">
                <use href="#cpu" />
              </svg>
              AI 전문 인력이 부족한 조직
            </div>
            <p>별도 AI 인프라를 준비하는 부담을 줄여 빠르게 시작</p>
            <div className="ill">
              <div className="ui" style={{ left: "0", right: "0", top: "0" }}>
                <div className="uih">
                  <b>예시 워크플로우</b>
                  <span className="bdg p">3</span>
                </div>
                <div className="row">
                  <span className="ico" style={{ background: "var(--grn)", width: "26px", height: "26px", borderRadius: "8px" }}>
                    <svg className="i" style={{ width: "13px", height: "13px" }}>
                      <use href="#msg" />
                    </svg>
                  </span>
                  사내 문서 RAG 챗봇
                  <span className="tg btn p sm" style={{ height: "26px", padding: "0 10px", fontSize: "11px" }}>
                    불러오기
                  </span>
                </div>
                <div className="row">
                  <span className="ico" style={{ background: "var(--org)", width: "26px", height: "26px", borderRadius: "8px" }}>
                    <svg className="i" style={{ width: "13px", height: "13px" }}>
                      <use href="#clock" />
                    </svg>
                  </span>
                  DB 조회 자동 보고 메일
                  <span className="tg bdg p">템플릿</span>
                </div>
                <div className="row">
                  <span className="ico" style={{ background: "#fff", boxShadow: "0 0 0 1px var(--g2)", width: "26px", height: "26px", borderRadius: "8px" }}>
                    <img src="/site/logos/notion.svg" alt="" style={{ width: "14px", height: "14px" }} />
                  </span>
                  Notion 신규 항목 → Gmail 알림
                  <span className="tg bdg p">템플릿</span>
                </div>
              </div>
              <span className="cursor" style={{ right: "12px", top: "84px" }}>
                <svg viewBox="0 0 22 22">
                  <use href="#ptr" />
                </svg>
              </span>
            </div>
          </div>
          <div className="bc hasgo gs rv d1">
            <div className="t">
              <svg className="i">
                <use href="#layers" />
              </svg>
              사내 데이터가 흩어진 조직
            </div>
            <p>여러 곳에 있는 파일·웹·DB 데이터를 모아 함께 활용</p>
            <div className="ill">
              <div className="ui" style={{ left: "0", top: "8px", width: "230px", transform: "rotate(-3deg)" }}>
                <div className="row" style={{ border: "0" }}>
                  <span className="ico" style={{ background: "#FDECEC", color: "#E5484D", fontSize: "9px", fontWeight: "800" }}>
                    PDF
                  </span>
                  파일 업로드
                  <span className="tg bdg g">완료</span>
                </div>
              </div>
              <div className="ui" style={{ left: "60px", top: "70px", width: "230px", transform: "rotate(2deg)" }}>
                <div className="row" style={{ border: "0" }}>
                  <span className="ico" style={{ background: "var(--blu)" }}>
                    <svg className="i">
                      <use href="#globe" />
                    </svg>
                  </span>
                  웹 크롤링
                  <span className="tg bdg b">수집 중</span>
                </div>
              </div>
              <div className="ui" style={{ left: "20px", top: "132px", width: "230px", transform: "rotate(-1deg)" }}>
                <div className="row" style={{ border: "0" }}>
                  <span className="ico" style={{ background: "var(--org)" }}>
                    <svg className="i">
                      <use href="#db" />
                    </svg>
                  </span>
                  복합 데이터 소스
                  <span className="tg bdg o">연결</span>
                </div>
              </div>
              <div className="ui hl" style={{ right: "20px", top: "136px", width: "200px", padding: "12px 16px", display: "flex", alignItems: "center", gap: "10px" }}>
                <span className="ico" style={{ background: "var(--ac)" }}>
                  <svg className="i">
                    <use href="#book" />
                  </svg>
                </span>
                <b style={{ fontSize: "14px" }}>지식베이스</b>
              </div>
            </div>
          </div>
          <div className="bc hasgo go rv d2">
            <div className="t">
              <svg className="i">
                <use href="#repeat" />
              </svg>
              반복 업무가 많은 조직
            </div>
            <p>반복 업무를 AI Agent로 자동화해 업무 시간 절약</p>
            <div className="ill">
              <div className="ui" style={{ left: "0", right: "0", top: "0" }}>
                <div className="uih">
                  <b>스케줄 실행 결과 · 최근 7일</b>
                </div>
                <div style={{ display: "flex", alignItems: "flex-end", gap: "10px", height: "96px", padding: "0 16px 14px" }}>
                  <i style={{ flex: "1", height: "40%", borderRadius: "6px", background: "var(--grn)" }} />
                  <i style={{ flex: "1", height: "65%", borderRadius: "6px", background: "var(--grn)" }} />
                  <i style={{ flex: "1", height: "50%", borderRadius: "6px", background: "var(--grn)" }} />
                  <i style={{ flex: "1", height: "85%", borderRadius: "6px", background: "var(--grn)" }} />
                  <i style={{ flex: "1", height: "70%", borderRadius: "6px", background: "var(--grn)" }} />
                  <i style={{ flex: "1", height: "30%", borderRadius: "6px", background: "#FCA5A5" }} />
                  <i style={{ flex: "1", height: "95%", borderRadius: "6px", background: "var(--grn)" }} />
                </div>
                <div style={{ display: "flex", gap: "14px", padding: "0 16px 14px", fontSize: "12px", color: "var(--t3)" }}>
                  <span style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                    <span className="dt" style={{ background: "var(--grn)" }} />
                    성공
                  </span>
                  <span style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                    <span className="dt" style={{ background: "#F87171" }} />
                    실패
                  </span>
                </div>
              </div>
              <div className="toast" style={{ left: "50%", transform: "translateX(-50%)", top: "138px" }}>
                <i>
                  <svg className="i">
                    <use href="#check" />
                  </svg>
                </i>
                Gmail 발송 완료
                <span>방금</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
